import actions from "./actions";

const {FETCH_LEAVE, FETCH_LEAVES, RESET_LEAVE} = actions;
const initState = {
    leaves: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    leave: {_id: null}
};

const LeaveReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_LEAVES:
            return {
                ...state,
                leaves: data
            }
        case RESET_LEAVE:
            return {
                ...state,
                leave: initState.leave,
            };
        case FETCH_LEAVE:
            return {
                ...state,
                leave: data,
            };
        default:
            return state;
    }
}

export default LeaveReducer;